/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Hotel set feature related request structures are defined here
 */

export const API = {
  GET_ALL_HOTEL_GROUPS: {
    path: '/organizations/:organizationId/configurations/hotel-group?:query',
    method: 'GET',
  },
  POST_HOTEL_GROUP: {
    path: '/organizations/:organizationId/configurations/hotel-group',
    method: 'POST',
  },
  DELETE_HOTEL_GROUP: {
    path: '/organizations/:organizationId/configurations/hotel-group?:query',
    method: 'DELETE',
  },
  GET_HOTELS: {
    path: '/organizations/:organizationId/hotels?:query',
    method: 'GET',
  },
  GET_SCHEMA_MAPPING: {
    path: '/organizations/:organizationId/config/schema-mapping',
    method: 'GET',
  },
};
//
export const LABELS = {
  GROUP_HOTEL: 'Hotel Set',
};
//
export const FIELD = [
  'hotel',
  'hotelClassification',
  'chainName',
  'hotelType',
  'city',
  'state',
  'country',
];
